export default __webpack_public_path__ + "3150ac3c62c0c24835f455d7eec347b7.png";